module.exports = __webpack_public_path__ + "img/31.2b6f7604.jpg";